//@flow

import { useQuery, type QueryResult } from 'react-query';
import useClientId from 'common/hooks/useClientId';
import usePersonnel from 'common/hooks/usePersonnel';
import { contactSearch } from 'common/modules/chat/middleware/api';

import type { ContactType } from 'common/modules/chat/components/Contacts/Contact';

type ContactsAPIResponse = {
    contacts: Array<ContactType>
};

const useContactList = ({
    query,
    page
}: {
    query: string,
    page: number
}): QueryResult<ContactsAPIResponse> => {
    const clientId = useClientId();
    const { personnelId } = usePersonnel();

    return useQuery({
        queryKey: ['contact-search', query, page],
        queryFn: async () => {
            const params = { clientId, personnelId };
            const body = { query, page, size: 20 };
            const resp = contactSearch.post(params, body);

            return resp;
        },
        refetchOnWindowFocus: false
    });
};

export default useContactList;
